
import { formatJsonLocation as fjl, formatLocation } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";

export const eventsconfig = {

  account: {
    service:{
      name:'account',
      title:'Account',
      key:'rid',
      num: false,
      fields: ['rid','nam', 'shc', 'dsc', 'ati','atn', 'eni', 'enm', 'eti', 'aky', 'bii', 'bin', 'bic', 'cre', 'lgo', 'exi', 'sts', 'ast', 'stp'],
      params: {nam:'Service',shc:'Code',dsc:'Description',sts:'Status'},
      grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['atc','Type'],['enm','Entity'],['cre','Credits'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
            {id:'shc',label:'Code',type:'tf',req:0,ops:{}},
            {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
            {id:'ati',label:'Account Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'accounttype'}},
            {id:'eni',label:'Entity',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'entity'}},
            {id:'cre',label:'Credit',type:'nf',req:0,ops:{}},
            {id:'lgo',label:'Logo',type:'if',req:0,ops:{preview:true}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  event: {
    service:{
      name:'event',
      title:'Events',
      key:'rid',
      num:true,
      fields:['rid','rix','sfi','sfx','sfn','sfc','usi','usx','unm','mbn','eml',
              'eti','etn','etc','esi','esn','esc','tpi','tpx','tpn','tpc',
              'ttl','msg','pld','rtm','dcd','exi','sts','ast','stp'],

      params:{
        ttl:'Title',
        etn:'Type',
        esn:'State',
        tpn:'Topic',
        unm:'User'
      },

      grid:[
        ['ttl','Title'],
        ['unm','User'],
        ['sfn','Staff'],
        ['etn','Type'],
        ['esn','State'],
        ['tpn','Topic'],
        ['rtm','Read'],
        ['dcd','Created']
      ],

      bar:{pag:true,btn:['add','edit','del','view']},

      menu:{
        mnu:[
          {t:'Title',v:'ttl'},
          {t:'User',v:'unm'},
          {t:'Topic',v:'tpn'}
        ],
        def:'ttl'
      },

      eform:[
        {id:'usi',label:'User',type:'fa',req:1,cp:{t:'bcs',s:'user'}},
        {id:'sfi',label:'Staff',type:'fa',req:0,cp:{t:'bcs',s:'staff'}},
        {id:'tpi',label:'Topic',type:'fa',req:1,cp:{t:'bcs',s:'topic'}},
        {id:'eti',label:'Event Type',type:'fa',req:1,cp:{t:'bcs',s:'eventtype'}},
        {id:'esi',label:'State',type:'fa',req:1,cp:{t:'bcs',s:'eventstate'}},
        {id:'ttl',label:'Title',type:'tf',req:1},
        {id:'msg',label:'Message',type:'ta',req:1},
        {id:'pld',label:'Payload',type:'ta',req:0},
        {id:'exi',label:'Extra Info',type:'ta',req:0},
        {id:'sts',label:'Status',type:'fa',req:1,cp:{t:'lcs',s:'status'}}
      ]
    },

    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  alert:{
    service:{
      name:'alert',
      title:'Alerts',
      key:'rid',
      num:true,

      fields:[
        'rid','rix','sfi','sfx','sfc','sfn',
        'cci','ccx','ccc','ccn',
        'svi','svc','svn','svr',
        'ssi','ssc','ssn',
        'top',
        'ttl','shc','msg','src',
        'pld','ack','rsd',
        'dcd','exi','sts','ast','stp'
      ],

      params:{
        ttl:'Title',
        shc:'Code',
        svn:'Severity',
        ssn:'State'
      },

      grid:[
        ['ttl','Title'],
        ['shc','Code'],
        ['svn','Severity'],
        ['ssn','State'],
        ['sfn','Staff'],
        ['ccn','Cost Center'],
        ['ack','Ack'],
        ['rsd','Resolved']
      ],

      bar:{pag:true,btn:['add','edit','del','view']},

      menu:{
        mnu:[
          {t:'Title',v:'ttl'},
          {t:'Code',v:'shc'}
        ],
        def:'ttl'
      },

      eform:[
        {id:'sfi',label:'Staff',type:'fa',req:0,cp:{t:'bcs',s:'staff'}},
        {id:'cci',label:'Cost Center',type:'fa',req:0,cp:{t:'bcs',s:'costcenter'}},
        {id:'svi',label:'Severity',type:'fa',req:1,cp:{t:'bcs',s:'alertseverity'}},
        {id:'ssi',label:'State',type:'fa',req:1,cp:{t:'bcs',s:'alertstate'}},
        {id:'shc',label:'Alert Code',type:'tf',req:1},
        {id:'ttl',label:'Title',type:'tf',req:1},
        {id:'msg',label:'Message',type:'ta',req:1},
        {id:'src',label:'Source',type:'tf',req:0},
        {id:'pld',label:'Payload',type:'ta',req:0},
        {id:'sts',label:'Status',type:'fa',req:1,cp:{t:'lcs',s:'status'}}
      ]
    },

    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  announce:{
    service:{
      name:'announce',
      title:'Announcements',
      key:'rid',
      num:true,

      fields:[
        'rid','rix',
        'ttl','bdy',
        'msk','aud',
        'pbf','pbt',
        'aui','aux','aur',
        'ssi','ssc','ssn',
        'dcd','sts','ast','stp'
      ],

      params:{
        ttl:'Title',
        aur:'Author',
        ssn:'State'
      },

      grid:[
        ['ttl','Title'],
        ['aur','Author'],
        ['ssn','State'],
        ['pbf','Publish From'],
        ['pbt','Publish To'],
        ['dcd','Created']
      ],

      bar:{pag:true,btn:['add','edit','del','view']},

      menu:{
        mnu:[
          {t:'Title',v:'ttl'},
          {t:'Author',v:'aur'}
        ],
        def:'ttl'
      },

      eform:[
        {id:'ttl',label:'Title',type:'tf',req:1},
        {id:'bdy',label:'Body',type:'ta',req:1},
        {id:'ssi',label:'State',type:'fa',req:1,cp:{t:'bcs',s:'announcestate'}},
        {id:'aui',label:'Author',type:'fa',req:0,cp:{t:'bcs',s:'user'}},
        {id:'msk',label:'Mask',type:'tf',req:0},
        {id:'aud',label:'Audience',type:'ta',req:0},
        {id:'pbf',label:'Publish From',type:'dt',req:1},
        {id:'pbt',label:'Publish To',type:'dt',req:0},
        {id:'sts',label:'Status',type:'fa',req:1,cp:{t:'lcs',s:'status'}}
      ]
    },

    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  socketmap:{
    service:{
      name:'socketmap',
      title:'Socket Maps',
      key:'rid',
      num:true,

      fields:[
        'rid','rix','shc',
        'svi','svc',
        'aci','acc',
        'tpi','tpx','tpc',
        'tsc','tch',
        'ttl','msg','dsc',
        'exi','sts','ast','stp'
      ],

      params:{
        shc:'Code',
        svc:'Service',
        acc:'Action'
      },

      grid:[
        ['shc','Code'],
        ['svc','Service'],
        ['acc','Action'],
        ['tpc','Topic'],
        ['ttl','Title'],
        ['msg','Message'],
        ['sts','Status']
      ],

      bar:{pag:true,btn:['add','edit','del','view']},

      menu:{
        mnu:[
          {t:'Code',v:'shc'},
          {t:'Service',v:'svc'}
        ],
        def:'shc'
      },

      eform:[
        {id:'shc',label:'Code',type:'tf',req:1},
        {id:'svi',label:'Service',type:'fa',req:1,cp:{t:'bcs',s:'appservice'}},
        {id:'aci',label:'Action',type:'fa',req:1,cp:{t:'bcs',s:'serviceaction'}},
        {id:'tpi',label:'Topic',type:'fa',req:1,cp:{t:'bcs',s:'topic'}},
        {id:'ttl',label:'Title',type:'tf',req:1},
        {id:'msg',label:'Message',type:'ta',req:0},
        {id:'dsc',label:'Description',type:'ta',req:0},
        {id:'sts',label:'Status',type:'fa',req:1,cp:{t:'lcs',s:'status'}}
      ]
    },

    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },


}
